import type { CSSProperties } from 'react';

export const ValidRoutes = [
  '/sensors',
  '/timeline',
  '/charts',
  '/photo',
  '/map',
  '/crops',
  '/scoring',
  '/fields',
  '/devices',
  '/profile',
  '/members',
  '/workspaces',
  '/devices',
  '/devices-diagram',
  '/soil-sensor',
];

export const PathnamesMap = {
  dashboard: 'sensors',
  timeline: 'timeline',
  photo: 'photo',
  vegetation: 'vegetation',
  charts: 'charts',
  map: 'map',
  fields: 'fields',
  crops: 'crops',
  scoring: 'scoring',
  devices: 'devices',
  devicesDiagram: 'devices-diagram',
  team: 'members',
  soilSensor: 'soil-sensor',
  soilSensorCharts: 'charts-soil',
  navigator: 'navigator',
  workspaces: 'workspaces',
};

export const AuthPathNamesMap = {
  signup: 'signup',
  login: 'login',
}

export const TabBarSensorStyle: CSSProperties = {
  paddingLeft: 24,
  paddingRight: 24,
  backgroundColor: 'var(--main)',
  margin: 0,
  position: 'sticky',
  top: 0,
  zIndex: 2,
};
export const TabBarSensorStyleMobile: CSSProperties = {
  paddingLeft: 16,
  paddingRight: 16,
  backgroundColor: 'var(--main)',
  margin: 0,
  position: 'sticky',
  top: 0,
  zIndex: 2,
};

// Breakpoints
export const BreakpointMobile = 767;
export const BreakpointMobileUp = 768;
export const BreakpointTablet = 991;
export const BreakpointTabletUp = 992;
export const BreakpointDesktop = 1279;
export const BreakpointDesktopUp = 1280;

export const ModalWidthSmall = 450;

export const DefaultBgPolygon = 'rgba(222, 236, 220, 0.40)';
export const DefaultBorderPolygon = '#fff';
export const ActiveBorderPolygon = '#efc336';
